import './card.css';
export default {
  "button": "pf-v6-c-button",
  "card": "pf-v6-c-card",
  "cardActions": "pf-v6-c-card__actions",
  "cardBody": "pf-v6-c-card__body",
  "cardClickableAction": "pf-v6-c-card__clickable-action",
  "cardExpandableContent": "pf-v6-c-card__expandable-content",
  "cardFooter": "pf-v6-c-card__footer",
  "cardHeader": "pf-v6-c-card__header",
  "cardHeaderMain": "pf-v6-c-card__header-main",
  "cardHeaderToggle": "pf-v6-c-card__header-toggle",
  "cardHeaderToggleIcon": "pf-v6-c-card__header-toggle-icon",
  "cardSelectableActions": "pf-v6-c-card__selectable-actions",
  "cardTitle": "pf-v6-c-card__title",
  "cardTitleText": "pf-v6-c-card__title-text",
  "check": "pf-v6-c-check",
  "checkInput": "pf-v6-c-check__input",
  "checkLabel": "pf-v6-c-check__label",
  "dirRtl": "pf-v6-m-dir-rtl",
  "divider": "pf-v6-c-divider",
  "modifiers": {
    "selectable": "pf-m-selectable",
    "clickable": "pf-m-clickable",
    "current": "pf-m-current",
    "selected": "pf-m-selected",
    "disabled": "pf-m-disabled",
    "compact": "pf-m-compact",
    "displayLg": "pf-m-display-lg",
    "secondary": "pf-m-secondary",
    "plain": "pf-m-plain",
    "expanded": "pf-m-expanded",
    "fullHeight": "pf-m-full-height",
    "toggleRight": "pf-m-toggle-right",
    "wrap": "pf-m-wrap",
    "noOffset": "pf-m-no-offset",
    "inline": "pf-m-inline",
    "noFill": "pf-m-no-fill"
  },
  "radio": "pf-v6-c-radio",
  "radioInput": "pf-v6-c-radio__input",
  "radioLabel": "pf-v6-c-radio__label"
};